import { NgModule } from '@angular/core';
import { AppSharedModule } from '@gestor-web/app/shared/modules';
import { LinksExternosComponent } from './links-externos.component';

@NgModule({
  declarations: [LinksExternosComponent],
  exports: [LinksExternosComponent],
  imports: [AppSharedModule],
})
export class LinksExternosModule {}
